import { Observable, of } from "rxjs"

abstract class LocalStorageRepository {
  static get(name: string): string | null | undefined {
    return typeof window !== "undefined" ? localStorage.getItem(name) : null
  }

  static set(name: string, value: string): void {
    typeof window !== "undefined" ? localStorage.setItem(name, value) : null
  }

  static remove(name: string): void {
    typeof window !== "undefined" ? localStorage.removeItem(name) : null
  }
}
export default LocalStorageRepository
